import React from 'react';

const Icon = () => (
  <g>
    <path
      d="M18.5 9.5H5.5C5.22386 9.5 5 9.72386 5 10V12.5C5 12.7761 5.22386 13 5.5 13H18.5C18.7761 13 19 12.7761 19 12.5V10C19 9.72386 18.7761 9.5 18.5 9.5Z"
      stroke="#D50000"
      strokeWidth="1.5"
    />
    <path
      d="M18.5 13H5.5C5.22386 13 5 13.2239 5 13.5V16C5 16.2761 5.22386 16.5 5.5 16.5H18.5C18.7761 16.5 19 16.2761 19 16V13.5C19 13.2239 18.7761 13 18.5 13Z"
      stroke="#D50000"
      strokeWidth="1.5"
    />
    <path
      d="M18.5 16.5H5.5C5.22386 16.5 5 16.7239 5 17V19.5C5 19.7761 5.22386 20 5.5 20H18.5C18.7761 20 19 19.7761 19 19.5V17C19 16.7239 18.7761 16.5 18.5 16.5Z"
      stroke="#D50000"
      strokeWidth="1.5"
    />
    <path
      d="M12 3.5V7"
      stroke="#D50000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 3.5L10 5"
      stroke="#D50000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 3.5L14 5"
      stroke="#D50000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </g>
);

export default Icon;
